(function () {
    'use strict';

    function service($http) {

        const get = (id, filter) =>
            $http.get('/webapi/admissionstransparency/get?id=' + id + '&filter=' + filter || '')
                .then(result => result.data);

        return {
            get
        }
    }

    angular.module('Uscapp').service('transparencyService', ['$http', service]);
}());